import Menu from "../../Components/Menu";
import Footer from "../../Components/Footer";
import { Container, Product, Wrapper } from "./styles";
import { MulherCorrendoPorDoSol, MulherTreinando } from "../../Components/imgs";
import {
	LuApple,
	LuBadgeCheck,
	LuDna,
	LuDumbbell,
	LuLightbulb,
	LuScrollText,
} from "react-icons/lu";

export default function Products() {
	document.title = "DNA for Performance - Produtos";

	const whatsappMessage = encodeURIComponent(
		"Oii tudo bem? Quero agendar minha análise"
	);

	const whatsappLink = `https://wa.me/5541984146397?text=${whatsappMessage}%21`;

	return (
		<>
			<Menu />
			<Container>
				<Wrapper>
					<div className="top-content">
						<h1>
							Genética, Nutrição e Performance Física com Base Científica
							Descubra como seu DNA pode transformar seus resultados
							<br />
							<span style={{ color: "black" }}>
								Descubra como seu DNA pode transformar seus resultados
							</span>
						</h1>

						<p>
							Combinamos ciência, genética avançada, planejamento físico
							individualizado e nutrição personalizada para oferecer um
							atendimento exclusivo, baseado em evidências e 100% adaptado ao
							seu perfil biológico.
						</p>
					</div>
					<div className="product-wrapper">
						<Product>
							<img src={MulherCorrendoPorDoSol} alt="" />
							<div className="info">
								<div className="title-wrapper">
									<div>
										<LuDna />
									</div>
									<h2>Análise de Painel Genético para Performance e Saúde</h2>
								</div>
								<div className="subinfo">
									<p>
										Ao adquirir nosso produto, seu material genético será
										coletado de forma <strong>rápida e prática</strong> , e te
										forneceremos uma análise detalhada do seu genoma e dos
										polimorfismos genéticos associados a atividade física, o que
										permitirá Identificar a melhor atividade física e tipo de
										treino de acordo que o seu corpo responde melhor, intervalos
										ideais de descanso, baseado em riscos inflamatórios, lesões
										e deficiências nutricionais, além de propor melhores tipos
										de dietas e suplementos para otimizar seus objetivos,
										afinal, de acordo com o nosso DNA, cada um de nós é único!
										Para isso, utilizamos tecnologia de ponta nas análises
										genéticas e construímos nossos laudos pautados em evidências
										científicas{" "}
										<strong>robustas e atuais (pesquisas nível A1-A3).</strong>
									</p>
									<ul>
										<h3>
											<LuScrollText /> O que você recebe?
										</h3>
										<p>
											<LuBadgeCheck color="var(--main-green)" strokeWidth={3} />
											 Laudo detalhado e 100% personalizado com explicações
											sobre seus marcadores genéticos
										</p>
										<ul>
											<h4>
												<LuBadgeCheck
													color="var(--main-green)"
													strokeWidth={3}
												/>
												 🎓 Sessão com nosso time de especialistas
											</h4>
											<li>
												1h com nutricionista especialista em nutrigenômica
											</li>
											<li>
												1h com educador físico especializado em genética
												esportiva
											</li>
											<p>
												<LuLightbulb /> Eles vão te ajudar a traduzir seu DNA em
												estratégias reais para treinar, comer e viver de forma
												mais inteligente e eficaz.
											</p>
										</ul>
									</ul>
								</div>
							</div>
						</Product>
						<Product>
							<div className="info">
								<div className="title-wrapper">
									<div>
										<LuDumbbell color="black" strokeWidth={2} />
									</div>
									<h2>
										 Elaboração de Programas de Treinamento Personalizados
									</h2>
								</div>

								<div className="subinfo">
									<h4>
										Criamos planilhas de treino totalmente ajustadas ao seu
										perfil genético, focando em:
									</h4>
									<ul>
										<li>Potência, força, resistência ou velocidade</li>
										<li>Redução de risco de lesão</li>
										<li>Otimização da recuperação</li>
										<li>
											Planejamento de periodização com base na sua resposta
											genética ao esforço físico
										</li>
									</ul>
									<ul>
										<h2>
											<LuApple strokeWidth={3} color="red" />  Acompanhamento
											Nutricional
										</h2>
										<h4>
											Nossa equipe oferece acompanhamento profissional em
											nutrição esportiva, com:
										</h4>
										<p>
											Ajustes em dietas e suplementos para performance ou
											mudança de composição corporal com base em marcadores
											genéticos e sua história clínica Estratégias
											personalizadas para{" "}
											<strong>
												ganho de massa, perda de gordura,
												performance ou longevidade
											</strong>
										</p>
									</ul>
								</div>
							</div>
							<img src={MulherTreinando} alt="" />
						</Product>
					</div>
				</Wrapper>
				<div className="btn-wrapper">
					<a href={whatsappLink} target="_blank" rel="noreferrer">
						Gostou? Agende já sua analise!
					</a>
				</div>
			</Container>
			<Footer />
		</>
	);
}
